<div class="checkout-step checkout-delivery-address">
  <div class="checkout-step-content">
    <span class="label-step">{{ 'checkout.deliveryAddress.title' | translate }}</span>

    <ng-container *ngIf="addressState$ | async as state">
      <ng-container *ngIf="state.loaded; else loadingTpl">
        <ng-container *ngIf="state.data; else noAddressTpl">
          <div class="address-card">
            <div class="address-card-header">
              <span class="material-symbols-outlined">location_on</span>
              <span class="address-card-label">{{ 'checkout.deliveryAddress.shippingAddress' | translate }}</span>
            </div>
            <div class="address-card-body">
              <p *ngIf="state.data.firstname || state.data.lastname" class="address-recipient">
                {{ state.data.firstname }} {{ state.data.lastname }}
              </p>
              <p *ngIf="state.data.streetname" class="address-line">
                {{ state.data.streetname }}{{ state.data.streetnumber ? ', ' + state.data.streetnumber : ''
                }}{{ state.data.complement ? ' – ' + state.data.complement : '' }}
              </p>
              <p *ngIf="state.data.district" class="address-line">
                {{ state.data.district }}
              </p>
              <p *ngIf="state.data.town || state.data.postalcode" class="address-line">
                {{ state.data.town }}{{ state.data.postalcode ? ', ' + state.data.postalcode : '' }}
              </p>
              <p *ngIf="state.data.country" class="address-line">
                {{ state.data.country }}
              </p>
              <p *ngIf="state.data.phone1" class="address-line">
                {{ state.data.phone1 }}
              </p>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-template #noAddressTpl>
      <div class="address-missing-banner">
        <span class="material-symbols-outlined address-missing-banner__icon">warning</span>
        <div class="address-missing-banner__content">
          <p class="address-missing-banner__title">{{ 'checkout.deliveryAddress.noAddress.title' | translate }}</p>
          <p class="address-missing-banner__description">{{ 'checkout.deliveryAddress.noAddress.description' | translate }}</p>
        </div>
      </div>
    </ng-template>

    <ng-template #loadingTpl>
      <div class="address-card address-card--loading">
        <span class="material-symbols-outlined">location_on</span>
        <span>{{ 'checkout.deliveryAddress.loading' | translate }}</span>
      </div>
    </ng-template>
  </div>
</div>
